module.exports = __webpack_public_path__ + "img/wells-fargo.6b5b8164.png";